import Backbone from "backbone";
import * as _ from "underscore";

import * as splitTest from "splitTest";

export const events = _.extend({}, Backbone.Events);
let user;

/**
 * Initialize walkthrough module.
 *
 * @param injectedUser - The user model to be used by the walkthrough module. This is injected
 *                       instead of imported for use in the browser extension.
 */
export const init = (injectedUser) => {
  user = injectedUser;
  window.addEventListener("appinstalled", () => {
    setAchievement("standalone", true);
  });
};

export const hasAchievement = (achievement) => {
  const acheivements = user.get("acheivements");
  return acheivements && acheivements.indexOf(achievement) > -1;
};

export const setAchievement = async (achievement, value?: boolean) => {
  let acheivements = _.clone(user.get("acheivements"));

  if (!acheivements) {
    acheivements = [];
  }
  let index = acheivements.indexOf(achievement);
  let changed = false;

  if (index > -1 && typeof value !== "undefined" && value === false) {
    acheivements.splice(index, 1);
    changed = true;
  }
  if (index === -1 && (typeof value === "undefined" || value === true)) {
    acheivements.push(achievement);
    changed = true;
  }
  if (changed) {
    await user.save(
      {
        acheivements: acheivements,
      },
      {
        patch: true,
        success: function () {
          splitTest.trackEventWithProperties("gotAchievement", {
            achievement,
            value,
            // A more consistent way to populate local user properties would be better than this
            // ad-hoc approach
            "Learning Language": user.get("currentLearningLanguage"),
            "From Language": user.get("firstLanguage"),
          });
        },
        error: function () {},
      }
    );
    events.trigger("new", achievement, value);
  }
};
